import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpenEprofileAllergia(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormCloseEprofileAllergia(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },
    modifyAgensInputType(state, eesztId) {
        let tempArray = state.headerFieldsEprofileAllergia;

        tempArray.map(item => {
            if(["agensELELMISZER", "agensKORNYEZETI_TENYEZO", "agensOGYEI", "agensEGYEB"].includes(item.name)){
                item.formVisible = item.agensId === eesztId;
            }
            return item;
        })
    }
}
